var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 126 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-995.236,-2172.45)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-342,32)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,100.764,-211.55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1263.54,2377.63L1263.54,2416.32C1263.54,2425.34 1270.78,2432.65 1279.69,2432.65C1281.7,2432.65 1283.63,2433.46 1285.06,2434.91C1286.48,2436.35 1287.27,2438.31 1287.26,2440.34C1287.26,2440.34 1287.24,2445.92 1287.24,2445.92L1308.12,2433.68C1309.27,2433.01 1310.58,2432.65 1311.92,2432.65L1334.93,2432.65L1334.93,2441.95C1334.93,2450.97 1327.7,2458.28 1318.78,2458.28L1284.85,2458.28C1283.52,2458.28 1282.21,2458.64 1281.05,2459.32L1260.17,2471.55C1260.17,2471.55 1260.2,2465.97 1260.2,2465.97C1260.2,2463.94 1259.41,2461.98 1257.99,2460.54C1256.57,2459.1 1254.64,2458.28 1252.62,2458.28C1243.71,2458.28 1236.47,2450.97 1236.47,2441.95C1236.47,2441.95 1236.47,2393.97 1236.47,2393.97C1236.47,2384.95 1243.71,2377.63 1252.62,2377.63L1263.54,2377.63Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-342,32)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,100.764,-211.55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1263.54,2377.63L1263.54,2368.33C1263.54,2359.32 1270.78,2352 1279.69,2352C1279.69,2352 1345.85,2352 1345.85,2352C1354.76,2352 1362,2359.32 1362,2368.33L1362,2416.32C1362,2425.34 1354.76,2432.65 1345.85,2432.65L1334.93,2432.65L1334.93,2393.97C1334.93,2384.95 1327.7,2377.63 1318.78,2377.63L1263.54,2377.63Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1b95f7fcdc09303547f8b14fe2eebd05.svg";
export { ForwardRef as ReactComponent };